import React, { useState ,useEffect} from "react";
import {  useDispatch } from "react-redux";
import { renderMatches, useLocation } from "react-router-dom";
import GlobalLoader from "./CommonC/GlobalLoader";
import StepperRisk from "./StepperRisk";
import Importriskcsv from "./Pages/Importriskcsv";
import ResultsRisk from "./Pages/ResultsRisk";
import PredictionRisk from "./Pages/PredictionRisk";
import SelexRiskNavbar from "./CommonC/SelexRiskNavbar";




const menuprops = {
  PaperProps: {
    style: {
      maxHeight: 50,
      width:50
    },
  },
};



function SelexRiskLandingPage(props) {
      const [loadednew, setLoadedNew] = React.useState(false);
      const [pid, setPid] = React.useState(false);
      const [pname, setPname] = React.useState(false);
        const [edit, setEdit] = React.useState(true);
        const [currentStep, setCurrentStep] = useState(0);
          const steps = [
            "Import Data",
            "Results",
            "Predictions"
            
          ];
      
    const [isLoading, setIsLoading] = React.useState(false);
  let loaded = false;
  let ProjectID = false;
  let projectName = false;
  let editAccess = true;
  const location = useLocation();
  console.log("location",location.state)
  const dispatch = useDispatch();
   useEffect(() => {
      if (location.state.loaded) {
        setLoadedNew(location.state.loaded);
      }
    }, [location.state.loaded]);
    
    useEffect(() => {
      if (location.state.ProjectID) {
        ProjectID = location.state.ProjectID;
        setPid(ProjectID)
      }
    }, [location.state.ProjectID]);
    
    useEffect(() => {
      if (location.state.projectName) {
        projectName = location.state.projectName;
        setPname(projectName)
      }
    }, [location.state.projectName]);
    
    useEffect(() => {
      if (location.state.editAccess) {
        setEdit(location.state.editAccess);
      }
    }, [location.state.editAccess]);
  
   const handleNextStep = () => {
    setCurrentStep(currentStep + 1);
  };
  const setCurrentStepFunc = (value) => {
    return setCurrentStep(value);
  };
  console.log(loadednew,pid,pname,editAccess)


  return (
    <div>
      <div className="popup">
   

      <SelexRiskNavbar />
       <StepperRisk
              setCurrentStepFunc={setCurrentStepFunc}
              allSteps={steps}
              currentStep={currentStep}
            />
            {currentStep === 0 ? (
              <Importriskcsv
                handleNextStep={handleNextStep}
                loaded={loadednew}
                ProjectID={pid}
                projectName={pname}
                editAccess={editAccess}
              />
            ) : currentStep === 1 ? (
              <ResultsRisk
                handleNextStep={handleNextStep}
                loaded={loaded}
                ProjectID={ProjectID}
                editAccess={editAccess}
              />
              
            ) : currentStep === 2 ? (
              <PredictionRisk
                handleNextStep={handleNextStep}
                loaded={loaded}
                ProjectID={ProjectID}
                editAccess={editAccess}
              />
              
            ) 
             : null}
      </div>

     
      {isLoading ? <GlobalLoader /> : null}
    </div>
  );
}

export default SelexRiskLandingPage;
